import { useTranslation } from 'react-i18next';
import { ReactComponent as WarningIcon } from 'assets/icons/warning-circle.svg';

import ChatStepIcon from '../ChatStepIcon';

import type { ReactElement } from 'react';
import type IAiChatDisplayFailed from '../../interfaces/IAiChatDisplayFailed';

import styles from '../../sass/AiChat.module.scss';

/**
 * The slot of a display tool whose call showed nothing: one line saying what could not be shown.
 * The reason is written for the model, which reads it and writes the reply another way; the
 * reader only learns that the display did not come, so the reply's text explains itself.
 *
 * Unlike a display that came, this is a step of the reply, not its output: the model goes on from
 * here. So it wears the step icon and sits on the connector, like every other step.
 */
function AiChatDisplayFailed({ type }: IAiChatDisplayFailed): ReactElement {
  const { t } = useTranslation();

  return (
    <div className={styles.stepRow}>
      <ChatStepIcon icon={<WarningIcon />} className={styles.stepIconError} />
      <div className={styles.tool}>
        <p className={styles.error}>{t('aiChat.tools.displayFailed', { type })}</p>
      </div>
    </div>
  );
}

export default AiChatDisplayFailed;
